export default {
  primary: 'linear-gradient(90deg, #FC6244 0%, #FC9256 98.89%)',
  secondary: 'linear-gradient(90deg, #003F73 100%, #0F5182 100%)',
};
